const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`e792c509a257d7f4bde227fed5186c7b751e5be8b08e56902372eda9a19de08a`, `e792c509a257d7f4bde227fed5186c7b751e5be8b08e56902372eda9a19de08a`, 1, 104), new Map([[`class`, `o-container--prose o-container--pad`]]), false, false, 1));
            }

            getTemplateName() {
                return `e792c509a257d7f4bde227fed5186c7b751e5be8b08e56902372eda9a19de08a`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e792c509a257d7f4bde227fed5186c7b751e5be8b08e56902372eda9a19de08a`, ``);
            }
        }],
        [104, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `e792c509a257d7f4bde227fed5186c7b751e5be8b08e56902372eda9a19de08a`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(`    <div data-test="contact-form" id="contact-form-test" class="wp-block-jetpack-contact-form-container " style="--jetpack--contact-form--primary-color: rgb(61, 132, 245); --jetpack--contact-form--background-color: rgb(255, 255, 255); --jetpack--contact-form--text-color: rgb(0, 0, 0); --jetpack--contact-form--border: 2px inset rgb(227, 227, 227); --jetpack--contact-form--border-color: rgb(227, 227, 227); --jetpack--contact-form--border-size: 2px; --jetpack--contact-form--border-style: inset; --jetpack--contact-form--border-radius: 0px; --jetpack--contact-form--input-background: rgb(255, 255, 255); --jetpack--contact-form--input-padding: 1px 2px; --jetpack--contact-form--input-padding-top: 1px; --jetpack--contact-form--input-padding-left: 2px; --jetpack--contact-form--font-size: 13.3333px; --jetpack--contact-form--font-family: -apple-system; --jetpack--contact-form--line-height: normal;">
      <form action="#contact-form-test" method="post" class="contact-form commentsblock wp-block-jetpack-contact-form">
        `);
                this.echo(`        <div></div>
        <div class="wp-block-jetpack-contact-form is-style-default" style="padding-top:16px;padding-right:16px;padding-bottom:16px;padding-left:16px">
          <div class="grunion-field-name-wrap grunion-field-wrap">
            <label for="gtest-name" class="grunion-field-label name">Name<span>(required)</span></label>
            <input type="text" name="gtest-name" id="gtest-name" value="" class="name  grunion-field" required="" aria-required="true">
          </div>



          <div class="grunion-field-email-wrap grunion-field-wrap">
            <label for="gtest-email" class="grunion-field-label email">Email<span>(required)</span></label>
            <input type="email" name="gtest-email" id="gtest-email" value="" class="email  grunion-field" required="" aria-required="true">
          </div>



          <div class="grunion-field-radio-wrap grunion-field-wrap">
            <label for="gtest-testwhoisyourfavoritemanager" class="grunion-field-label">Who is your favorite manager?</label>
            <div class="grunion-radio-options"> <label class="grunion-radio-label radio"><input type="radio" name="gtest-testwhoisyourfavoritemanager" value="Jason" class="radio  grunion-field"> Jason</label>
              <label class="grunion-radio-label radio"><input type="radio" name="gtest-testwhoisyourfavoritemanager" value="Aileen" class="radio  grunion-field"> Aileen</label>
              <label class="grunion-radio-label radio"><input type="radio" name="gtest-testwhoisyourfavoritemanager" value="Megan" class="radio  grunion-field"> Megan</label>
              <label class="grunion-radio-label radio"><input type="radio" name="gtest-testwhoisyourfavoritemanager" value="Some other guy, I can't quite remember" class="radio  grunion-field"> Some other guy, I can't quite remember</label>
            </div>
          </div>



          <div class="grunion-field-checkbox-multiple-wrap grunion-field-wrap">
            <label for="gtest-whichareyouhungryfor" class="grunion-field-label">Which are you hungry for?</label>
            <div class="grunion-checkbox-multiple-options"> <label class="grunion-checkbox-multiple-label checkbox-multiple "><input type="checkbox" name="gtest-whichareyouhungryfor[]" value="Pizza" class="checkbox-multiple  grunion-field"> Pizza</label>
              <label class="grunion-checkbox-multiple-label checkbox-multiple "><input type="checkbox" name="gtest-whichareyouhungryfor[]" value="Sandwiches" class="checkbox-multiple  grunion-field"> Sandwiches</label>
              <label class="grunion-checkbox-multiple-label checkbox-multiple "><input type="checkbox" name="gtest-whichareyouhungryfor[]" value="Chocolate" class="checkbox-multiple  grunion-field"> Chocolate</label>
            </div>
          </div>



          <div class="grunion-field-select-wrap grunion-field-wrap contact-form-dropdown-wrap ui-front">
            <label for="gtest-whyareyouwritingtoday" class="grunion-field-label select">Why are you writing today?<span>(required)</span></label>
            <select name="gtest-whyareyouwritingtoday" id="gtest-whyareyouwritingtoday" class="select  grunion-field contact-form-dropdown" required="" aria-required="true">
              <option>Select one option</option>
              <option value="I was just bored">I was just bored</option>
              <option value="I have a sweet new idea">I have a sweet new idea</option>
              <option value="Just wanted to pick your brain">Just wanted to pick your brain</option>
              <option value="I love email">I love email</option>
              <option value="Sorry, my cat sat on my keyboard">Sorry, my cat sat on my keyboard</option>
            </select>
          </div>



          <div class="grunion-field-text-wrap grunion-field-wrap">
            <label for="gtest-text" class="grunion-field-label text">Text</label>
            <input type="text" name="gtest-text" id="gtest-text" value="" class="text  grunion-field">
          </div>



          <div class="grunion-field-date-wrap jp-contact-form-date-wrap grunion-field-wrap">
            <label for="gtest-date" class="grunion-field-label date">Date</label>
            <input type="text" name="gtest-date" id="gtest-date" value="" class="date jp-contact-form-date grunion-field">
          </div>



          <div class="grunion-field-telephone-wrap grunion-field-wrap">
            <label for="gtest-phone" class="grunion-field-label telephone">Phone</label>
            <input type="tel" name="gtest-phone" id="gtest-phone" value="" class="telephone  grunion-field">
          </div>



          <div class="grunion-field-url-wrap grunion-field-wrap">
            <label for="gtest-website" class="grunion-field-label url">Website</label>
            <input type="text" name="gtest-website" id="gtest-website" value="" class="url  grunion-field" title="Please enter a valid URL - https://www.example.com" oninvalid="setCustomValidity(&quot;Please enter a valid URL - https://www.example.com&quot;)" oninput="setCustomValidity(&quot;&quot;)" pattern="(([:\\/a-zA-Z0-9_\\-]+)?(\\.[a-zA-Z0-9_\\-\\/]+)+)" data-type-override="url">
          </div>



          <div class="grunion-field-textarea-wrap grunion-field-wrap">
            <label for="contact-form-comment-gtest-message" class="grunion-field-label textarea">Message</label>
            <textarea name="gtest-message" id="contact-form-comment-gtest-message" rows="20" class="textarea  grunion-field"></textarea>
          </div>



          <div class="grunion-field-checkbox-wrap grunion-field-wrap">
            <label class="grunion-field-label checkbox"> <input type="checkbox" name="gtest-exampleofacheckbox" value="Yes" class="checkbox  grunion-field">
              Example of a checkbox</label>
            <div class="clear-form"></div>
          </div>



          <div class="grunion-field-consent-wrap grunion-field-wrap">
            <label class="grunion-field-label consent consent-implicit"> <input aria-hidden="true" type="checkbox" checked="" name="gtest-consent" value="Yes" style="display:none;">
              By submitting your information, you're giving us permission to email you. You may unsubscribe at any time.</label>
            <div class="clear-form"></div>
          </div>


          <div class="wp-block-jetpack-button wp-block-button"><button class="wp-block-button__link" data-id-attr="placeholder" type="submit">Contact Us</button></div>
        </div>
        <input type="hidden" id="_wpnonce" name="_wpnonce" value="test"><input type="hidden" name="_wp_http_referer" value="test">
        <input type="hidden" name="contact-form-id" value="test">
        <input type="hidden" name="action" value="grunion-contact-form">
        <input type="hidden" name="contact-form-hash" value="test">
      </form>
    </div>
  `);
            }

            getTemplateName() {
                return `e792c509a257d7f4bde227fed5186c7b751e5be8b08e56902372eda9a19de08a`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `e792c509a257d7f4bde227fed5186c7b751e5be8b08e56902372eda9a19de08a`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'e792c509a257d7f4bde227fed5186c7b751e5be8b08e56902372eda9a19de08a');

let template = env.loadTemplate('e792c509a257d7f4bde227fed5186c7b751e5be8b08e56902372eda9a19de08a');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/contact-form/form.twig", args: context }
     );
     return rendered;;
};